define('viewModels/privileged/composer/forms/formEditor/AddQuestionButtons',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/ViewModel',
    'models/composer/forms/questionTemplates',
    'services/composer/templateService'
], function (
    ko,
    _,
    ViewModel,
    defaultTemplates,
    templateService
) {
    "use strict";

    var AddQuestionButtonsViewModel = ViewModel.extend(function AddQuestionButtonsViewModel_init(formEditorState) {
        var self = this;

        var favoriteTemplateIds = formEditorState.favoriteTemplateIds;
        var questionTemplates = formEditorState.questionTemplates;
        //Constructs an object that exposes a label and a function for creating a question with given data
        var QuestionChoice = function(template) {
            this.name = template.name;
            this.id = template.id;
            this.isDefault = template.isDefault || false;
            this.templateData = template.data;
            this._primed = ko.observable(false);
            this.isFavorite = self.computed(function () {
                return this.isDefault || favoriteTemplateIds().indexOf(this.id) !== -1;
            }, this);
        };

        QuestionChoice.prototype.addQuestion = function (data, evt) {
            var parent = ko.contextFor(evt.target).$parent;
            parent.addQuestion(this.templateData);
        };

        QuestionChoice.prototype.toggleFavorite = function() {
            if(this.isDefault) {
                return; //For now, default templates are always favorite
            }
            //Optimistically update our list of favorite templates, and send a request to update the setting on the server
            //It's probably not a big deal if this fails.
            if(this.isFavorite()) {
                favoriteTemplateIds.remove(this.id);
                templateService.unsetFavoriteTemplate(templateService.EVALUATIONS_SERVICE, this.id);
            } else {
                favoriteTemplateIds.push(this.id);
                templateService.setFavoriteTemplate(templateService.EVALUATIONS_SERVICE, this.id);
            }
        };

        QuestionChoice.prototype.deleteTemplate = function() {
            if(this.isDefault) {
                //Shouldn't even be possible to trigger from HTML, but just to be safe
                return;
            }
            if(this._primed()) {
                var choice = this;
                templateService.deleteTemplate(templateService.EVALUATIONS_SERVICE, choice.id)
                .then(function () {
                    questionTemplates.remove(function (template) {
                        return template.id === choice.id;
                    });
                });
            } else {
                var self = this;
                window.setTimeout(function () {
                    self._primed(true);
                    window.setTimeout(function () {
                        self._primed(false);
                    }, 2000);
                }, 500);
            }
        };

        var createQuestionChoice = function(template) {
            return new QuestionChoice(template);
        };

        //Create a sorted list of QuestionChoice objects from the question templates
        self.questionChoices = ko.computed(function () {
            var allTemplates = _.invokeMap(questionTemplates(), "unwrap")
                                .concat(defaultTemplates().all);
            return _.chain(allTemplates)
             .map(createQuestionChoice)
             .sortBy("name")
             .value();
        });

        self.favoriteChoices = ko.computed(function () {
            return _.filter(self.questionChoices(), function (choice) {
                return choice.isFavorite();
            });
        });
    });

    return AddQuestionButtonsViewModel;

});
